import dayjs from "dayjs";
import { changeDaysjsFormat } from "./changeDaysjsFormat";

const Search = (table, search, tableName) => {
  let fileredByDepartment = [];
  let fileredByAddress = [];
  let filtredByAuthorisationDate = [];
  let filteredByStatus = [];
  let filteredByJobTitle = [];
  let filteredByName = [];
  let filtredByLeaveType = [];
  let filtredByHeadquarter = [];
  let filteredByNameLeavesTable = [];
  let filteredByNameAuthorisationTable = [];
  let filtredByDate = [];
  let filtredByRemoteRequestDate = [];
  let Rows = [];
  Rows = table?.filter((row) => {
    return search == null
      ? row
      : (tableName === "leave-types" &&
          row.name
            .trim()
            .toLowerCase()
            .includes(search?.name?.trim().toLowerCase())) ||
        (tableName === "department" &&
          row.name
            .trim()
            .toLowerCase()
            .includes(search?.name?.trim().toLowerCase())) ||
        (tableName === "headquarters" &&
          row.name
            ?.trim()
            ?.toLowerCase()
            ?.includes(search?.name?.trim().toLowerCase())) ||
        (tableName === "remoteRequests" &&
          row.user?.fullName
            ?.trim()
            ?.toLowerCase()
            ?.includes(search?.name?.trim().toLowerCase()))
      ? row
      : "";
  });

  // filter leaves table

  filtredByLeaveType = search?.leaveTypeID
    ? table?.filter((row) => {
        return search == null
          ? row
          : tableName === "leaves" || tableName === "leaves-history"
          ? row?.type?._id === search?.leaveTypeID
            ? row
            : ""
          : "";
      })
    : table;

  filtredByHeadquarter = search?.headquarterId
    ? (tableName === "users" ? table : filtredByLeaveType)?.filter((row) => {
        if (search == null) return row;
        if (tableName !== "leaves" && tableName !== "leaves-history" && tableName !== "authorisations" && tableName !== "remoteRequests" && tableName !== "users") return "";
        
        // For users table (employees), check row.headquarterId directly
        if (tableName === "users") {
          const userHeadquarterId = row?.headquarterId;
          const searchHeadquarterId = search?.headquarterId;
          
          // Handle both object and string formats
          const userHeadquarterIdValue = typeof userHeadquarterId === 'object' 
            ? userHeadquarterId?._id 
            : userHeadquarterId;
            
          return userHeadquarterIdValue === searchHeadquarterId ? row : "";
        }
        
        // For other tables, check row.user.headquarterId
        const userHeadquarterId = row?.user?.headquarterId;
        const searchHeadquarterId = search?.headquarterId;
        
        // Handle both object and string formats
        const userHeadquarterIdValue = typeof userHeadquarterId === 'object' 
          ? userHeadquarterId?._id 
          : userHeadquarterId;
          
        return userHeadquarterIdValue === searchHeadquarterId ? row : "";
      })
    : (tableName === "users" ? table : filtredByLeaveType);

  // Log matched records when filtering by headquarter
  if (search?.headquarterId && (tableName === "leaves" || tableName === "authorisations" || tableName === "remoteRequests" || tableName === "users")) {
    // Get all unique headquarter IDs from the data
    const sourceData = tableName === "users" ? table : filtredByLeaveType;
    const allHeadquarterIds = [...new Set(sourceData?.map(record => {
      // For users table, check record.headquarterId directly
      if (tableName === "users") {
        const userHeadquarterId = record?.headquarterId;
        return typeof userHeadquarterId === 'object' ? userHeadquarterId?._id : userHeadquarterId;
      }
      // For other tables, check record.user.headquarterId
      const userHeadquarterId = record?.user?.headquarterId;
      return typeof userHeadquarterId === 'object' ? userHeadquarterId?._id : userHeadquarterId;
    }).filter(Boolean))];
  }

  filtredByDate =
    search?.dateStart || search?.dateEnd
      ? table?.filter((row) => {
          const START = changeDaysjsFormat(search?.dateStart);
          const END = changeDaysjsFormat(search?.dateEnd);
          return search == null
            ? row
            : tableName === "leaves" || tableName === "leaves-history"
            ? dayjs(row?.dateStart).isBetween(dayjs(START), END) ||
              dayjs(row?.dateEnd).isBetween(dayjs(START), END) ||
              dayjs(row?.dateStart).isSame(dayjs(START), END) ||
              dayjs(row?.dateEnd).isSame(dayjs(END), START)
              ? row
              : ""
            : "";
        })
      : table;

  // Create a proper filtering chain for leaves table (same pattern as employees table)
  let filteredByDateAndLeaveType = filtredByDate;
  if (search?.leaveTypeID && (tableName === "leaves" || tableName === "leaves-history")) {
    filteredByDateAndLeaveType = filtredByDate?.filter((row) => {
      const matches = row?.type?._id === search?.leaveTypeID;
      // Debug log for leave type filtering
      if (search?.leaveTypeID && tableName === "leaves") {
        console.log("🔍 Leave Type Filter Debug:", {
          rowLeaveTypeId: row?.type?._id,
          rowLeaveTypeName: row?.type?.name,
          searchLeaveTypeId: search?.leaveTypeID,
          matches: matches
        });
      }
      return matches ? row : "";
    });
  }

  let filteredByDateLeaveTypeAndDepartment = filteredByDateAndLeaveType;
  if (search?.departmentID && (tableName === "leaves" || tableName === "leaves-history")) {
    filteredByDateLeaveTypeAndDepartment = filteredByDateAndLeaveType?.filter((row) => {
      // Handle both populated and unpopulated department fields
      const userDepartmentId = typeof row?.user?.department === 'object' 
        ? row?.user?.department?._id 
        : row?.user?.department;
      const matches = userDepartmentId === search?.departmentID;
      
      // Debug log for department filtering
      if (search?.departmentID && tableName === "leaves") {
        console.log("🔍 Department Filter Debug:", {
          rowDepartmentId: userDepartmentId,
          rowDepartmentName: typeof row?.user?.department === 'object' ? row?.user?.department?.name : 'N/A (unpopulated)',
          searchDepartmentId: search?.departmentID,
          matches: matches,
          userName: row?.user?.fullName,
          departmentType: typeof row?.user?.department
        });
      }
      return matches ? row : "";
    });
  }

  let filteredByDateLeaveTypeDepartmentAndHeadquarter = filteredByDateLeaveTypeAndDepartment;
  if (search?.headquarterId && (tableName === "leaves" || tableName === "leaves-history")) {
    filteredByDateLeaveTypeDepartmentAndHeadquarter = filteredByDateLeaveTypeAndDepartment?.filter((row) => {
      const userHeadquarterId = row?.user?.headquarterId;
      const searchHeadquarterId = search?.headquarterId;
      
      // Handle both object and string formats
      const userHeadquarterIdValue = typeof userHeadquarterId === 'object' 
        ? userHeadquarterId?._id 
        : userHeadquarterId;
        
      return userHeadquarterIdValue === searchHeadquarterId ? row : "";
    });
  }

  filteredByNameLeavesTable = search?.name
    ? filteredByDateLeaveTypeDepartmentAndHeadquarter?.filter((row) => {
        return search == null
          ? row
          : tableName === "leaves" || tableName === "leaves-history"
          ? row.user.fullName
              ?.trim()
              ?.toLowerCase()
              ?.includes(search?.name?.trim().toLowerCase())
            ? row
            : ""
          : "";
      })
    : search?.dateStart || search?.dateEnd
    ? filteredByDateLeaveTypeDepartmentAndHeadquarter
    : search?.leaveTypeID
    ? filteredByDateLeaveTypeDepartmentAndHeadquarter
    : search?.departmentID
    ? filteredByDateLeaveTypeDepartmentAndHeadquarter
    : search?.headquarterId
    ? filteredByDateLeaveTypeDepartmentAndHeadquarter
    : table;

  //filter authorisations table

  filtredByAuthorisationDate =
    search?.dateStart || search?.dateEnd
      ? table?.filter((row) => {
          const START = changeDaysjsFormat(search?.dateStart);
          const END = changeDaysjsFormat(search?.dateEnd);
          return search == null
            ? row
            : tableName === "authorisations" || tableName === "leaves-history"
            ? dayjs(row?.date).isBetween(dayjs(START), END) ||
              dayjs(row?.date).isBetween(dayjs(START), END) ||
              dayjs(row?.date).isSame(dayjs(START), END) ||
              dayjs(row?.date).isSame(dayjs(END), START)
              ? row
              : ""
            : "";
        })
      : table;

  // Add department filtering for authorisations table
  let filteredByAuthorisationDateAndDepartment = filtredByAuthorisationDate;
  if (search?.departmentID && tableName === "authorisations") {
    filteredByAuthorisationDateAndDepartment = filtredByAuthorisationDate?.filter((row) => {
      // Handle both populated and unpopulated department fields
      const userDepartmentId = typeof row?.user?.department === 'object' 
        ? row?.user?.department?._id 
        : row?.user?.department;
      const matches = userDepartmentId === search?.departmentID;
      
      // Debug log for department filtering in authorisations
      if (search?.departmentID && tableName === "authorisations") {
        console.log("🔍 Authorisations Department Filter Debug:", {
          rowDepartmentId: userDepartmentId,
          rowDepartmentName: typeof row?.user?.department === 'object' ? row?.user?.department?.name : 'N/A (unpopulated)',
          searchDepartmentId: search?.departmentID,
          matches: matches,
          userName: row?.user?.fullName,
          departmentType: typeof row?.user?.department
        });
      }
      return matches ? row : "";
    });
  }

  // Add headquarter filtering for authorisations table
  let filteredByAuthorisationDateDepartmentAndHeadquarter = filteredByAuthorisationDateAndDepartment;
  if (search?.headquarterId && tableName === "authorisations") {
    filteredByAuthorisationDateDepartmentAndHeadquarter = filteredByAuthorisationDateAndDepartment?.filter((row) => {
      const userHeadquarterId = row?.user?.headquarterId;
      const searchHeadquarterId = search?.headquarterId;
      
      // Handle both object and string formats
      const userHeadquarterIdValue = typeof userHeadquarterId === 'object' 
        ? userHeadquarterId?._id 
        : userHeadquarterId;
        
      return userHeadquarterIdValue === searchHeadquarterId ? row : "";
    });
  }

  filteredByNameAuthorisationTable = search?.name
    ? filteredByAuthorisationDateDepartmentAndHeadquarter?.filter((row) => {
        return search == null
          ? row
          : tableName === "authorisations" || tableName === "leaves-history"
          ? row.user.fullName
              ?.trim()
              ?.toLowerCase()
              ?.includes(search?.name?.trim().toLowerCase())
            ? row
            : ""
          : "";
      })
    : search?.dateStart || search?.dateEnd
    ? filteredByAuthorisationDateDepartmentAndHeadquarter
    : search?.departmentID
    ? filteredByAuthorisationDateDepartmentAndHeadquarter
    : search?.headquarterId
    ? filteredByAuthorisationDateDepartmentAndHeadquarter
    : table;

  // filter remote requests table by date
  filtredByRemoteRequestDate =
    search?.dateStart || search?.dateEnd
      ? table?.filter((row) => {
          const START = changeDaysjsFormat(search?.dateStart);
          const END = changeDaysjsFormat(search?.dateEnd);
          return search == null
            ? row
            : tableName === "remoteRequests"
            ? dayjs(row?.startDate).isBetween(dayjs(START), END) ||
              dayjs(row?.endDate).isBetween(dayjs(START), END) ||
              dayjs(row?.startDate).isSame(dayjs(START), END) ||
              dayjs(row?.endDate).isSame(dayjs(END), START)
              ? row
              : ""
            : "";
        })
      : table;

  // Add department filtering for remote requests table
  let filteredByRemoteRequestDateAndDepartment = filtredByRemoteRequestDate;
  if (search?.departmentID && tableName === "remoteRequests") {
    filteredByRemoteRequestDateAndDepartment = filtredByRemoteRequestDate?.filter((row) => {
      // Handle both populated and unpopulated department fields
      const userDepartmentId = typeof row?.user?.department === 'object' 
        ? row?.user?.department?._id 
        : row?.user?.department;
      const matches = userDepartmentId === search?.departmentID;
      
      // Debug log for department filtering in remote requests
      if (search?.departmentID && tableName === "remoteRequests") {
        console.log("🔍 Remote Requests Department Filter Debug:", {
          rowDepartmentId: userDepartmentId,
          rowDepartmentName: typeof row?.user?.department === 'object' ? row?.user?.department?.name : 'N/A (unpopulated)',
          searchDepartmentId: search?.departmentID,
          matches: matches,
          userName: row?.user?.fullName,
          departmentType: typeof row?.user?.department
        });
      }
      return matches ? row : "";
    });
  }

  // Add headquarter filtering for remote requests table
  let filteredByRemoteRequestDateDepartmentAndHeadquarter = filteredByRemoteRequestDateAndDepartment;
  if (search?.headquarterId && tableName === "remoteRequests") {
    filteredByRemoteRequestDateDepartmentAndHeadquarter = filteredByRemoteRequestDateAndDepartment?.filter((row) => {
      const userHeadquarterId = row?.user?.headquarterId;
      const searchHeadquarterId = search?.headquarterId;
      
      // Handle both object and string formats
      const userHeadquarterIdValue = typeof userHeadquarterId === 'object' 
        ? userHeadquarterId?._id 
        : userHeadquarterId;
        
      // Debug log for headquarter filtering in remote requests
      if (search?.headquarterId && tableName === "remoteRequests") {
        console.log("🔍 Remote Requests Headquarter Filter Debug:", {
          rowHeadquarterId: userHeadquarterIdValue,
          rowHeadquarterName: typeof userHeadquarterId === 'object' ? userHeadquarterId?.name : 'N/A (unpopulated)',
          searchHeadquarterId: searchHeadquarterId,
          matches: userHeadquarterIdValue === searchHeadquarterId,
          userName: row?.user?.fullName,
          headquarterType: typeof userHeadquarterId
        });
      }
        
      return userHeadquarterIdValue === searchHeadquarterId ? row : "";
    });
  }

  // Add name filtering for remote requests table
  let filteredByRemoteRequestDateDepartmentHeadquarterAndName = filteredByRemoteRequestDateDepartmentAndHeadquarter;
  if (search?.name && tableName === "remoteRequests") {
    filteredByRemoteRequestDateDepartmentHeadquarterAndName = filteredByRemoteRequestDateDepartmentAndHeadquarter?.filter((row) => {
      return row?.user?.fullName
        ?.trim()
        ?.toLowerCase()
        ?.includes(search?.name?.trim().toLowerCase()) ? row : "";
    });
  }

  // filter in users table
  fileredByDepartment = search?.departmentID
    ? table?.filter((row) => {
        return search == null
          ? row
          : tableName === "users"
          ? (typeof row?.department === 'object' ? row?.department?._id : row?.department) === search?.departmentID
            ? row
            : ""
          : tableName === "leaves" || tableName === "authorisations" || tableName === "remoteRequests"
          ? (typeof row?.user?.department === 'object' ? row?.user?.department?._id : row?.user?.department) === search?.departmentID
            ? row
            : ""
          : "";
      })
    : table;

  // Create a proper filtering chain for users table
  let filteredByDepartmentAndHeadquarter = fileredByDepartment;
  if (search?.headquarterId && tableName === "users") {
    filteredByDepartmentAndHeadquarter = fileredByDepartment?.filter((row) => {
      const userHeadquarterId = row?.headquarterId;
      const searchHeadquarterId = search?.headquarterId;
      
      // Handle both object and string formats
      const userHeadquarterIdValue = typeof userHeadquarterId === 'object' 
        ? userHeadquarterId?._id 
        : userHeadquarterId;
        
      return userHeadquarterIdValue === searchHeadquarterId ? row : "";
    });
  }

  filteredByStatus = search?.status
    ? filteredByDepartmentAndHeadquarter?.filter((row) => {
        return search == null
          ? row
          : tableName === "users"
          ? row.status
              .trim()
              .toLowerCase()
              .includes(search?.status?.trim().toLowerCase())
            ? row
            : ""
          : "";
      })
    : filteredByDepartmentAndHeadquarter;

  let filteredByState = search?.state
    ? filteredByStatus?.filter((row) => {
        return search == null
          ? row
          : tableName === "headquarters"
          ? row.state
              ?.trim()
              ?.toLowerCase()
              ?.includes(search?.state?.trim().toLowerCase())
            ? row
            : ""
          : "";
      })
    : search?.status
    ? filteredByStatus
    : search?.departmentID
    ? fileredByDepartment
    : table;

  let filteredByDelegation = search?.delegation
    ? filteredByState?.filter((row) => {
        return search == null
          ? row
          : tableName === "headquarters"
          ? row.delegation
              ?.trim()
              ?.toLowerCase()
              ?.includes(search?.delegation?.trim().toLowerCase())
            ? row
            : ""
          : "";
      })
    : search?.state
    ? filteredByState
    : search?.status
    ? filteredByStatus
    : search?.departmentID
    ? fileredByDepartment
    : table;

  filteredByJobTitle = search?.jobTitle
    ? filteredByStatus?.filter((row) => {
        return search == null
          ? row
          : tableName === "users"
          ? row.jobTitle
              .trim()
              .toLowerCase()
              .includes(search?.jobTitle?.trim().toLowerCase())
            ? row
            : ""
          : "";
      })
    : search?.status
    ? filteredByStatus
    : search?.departmentID
    ? fileredByDepartment
    : table;

  fileredByAddress = search?.address
    ? filteredByDelegation?.filter((row) => {
        return search == null
          ? row
          : tableName === "users"
          ? row?.address
              ?.trim()
              ?.toLowerCase()
              ?.includes(search?.address?.trim().toLowerCase())
            ? row
            : ""
          : tableName === "headquarters"
          ? row?.address
              ?.trim()
              ?.toLowerCase()
              ?.includes(search?.address?.trim().toLowerCase())
            ? row
            : ""
          : "";
      })
    : search?.delegation
    ? filteredByDelegation
    : search?.jobTitle
    ? filteredByJobTitle
    : search?.status
    ? filteredByStatus
    : search?.departmentID
    ? fileredByDepartment
    : table;

  filteredByName = search?.name
    ? fileredByAddress?.filter((row) => {
        return search == null
          ? row
          : tableName === "users"
          ? row.fullName
              ?.trim()
              ?.toLowerCase()
              ?.includes(search?.name?.trim().toLowerCase())
            ? row
            : ""
          : tableName === "headquarters"
          ? row.name
              ?.trim()
              ?.toLowerCase()
              ?.includes(search?.name?.trim().toLowerCase())
            ? row
            : ""
          : "";
      })
    : search?.address
    ? fileredByAddress
    : search?.delegation
    ? filteredByDelegation
    : search?.state
    ? filteredByState
    : search?.jobTitle
    ? filteredByJobTitle
    : search?.status
    ? filteredByStatus
    : search?.departmentID || search?.headquarterId
    ? filteredByStatus
    : search?.leaveTypeID
    ? filtredByLeaveType
    : table;

  const result = tableName === "leaves" || tableName === "leaves-history"
    ? filteredByNameLeavesTable
    : tableName === "authorisations" || tableName === "leaves-history"
    ? filteredByNameAuthorisationTable
    : tableName === "remoteRequests"
    ? filteredByRemoteRequestDateDepartmentHeadquarterAndName
    : tableName === "users"
    ? filteredByName
    : tableName === "headquarters"
    ? filteredByName
    : Rows;

  return result;
};

export default Search;
